import { Box, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import React from "react";

interface UpDownButtonsProps {
  inputRef: React.RefObject<null | HTMLInputElement>;
  disabled?: boolean;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  valueChanged: React.RefObject<boolean>;
}

const buttonStyles: React.CSSProperties = {
  width: "20px !important",
  height: "50%",
  borderRadius: "0px",
  padding: "0",
};

const iconStyles: React.CSSProperties = {
  maxHeight: "10px",
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function UpDownButtons(props: UpDownButtonsProps) {
  const changeValue = (delta: number) => {
    const value = Number(props.inputValue);
    if (Number.isNaN(value)) return;
    props.setInputValue(String(value + delta));
    props.valueChanged.current = true;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      borderRadius={0}
      padding={0}
    >
      <IconButton disabled={props.disabled} style={buttonStyles} onClick={() => changeValue(1)}>
        <ExpandLessIcon style={iconStyles} />
      </IconButton>
      <IconButton disabled={props.disabled} style={buttonStyles} onClick={() => changeValue(-1)}>
        <ExpandMoreIcon style={iconStyles} />
      </IconButton>
    </Box>
  );
}
